import React from 'react';

const BrandLogos = () => {
    const brands = [
        {
            imageUrl: 'https://media.about.nike.com/img/cf68f541-fc92-4373-91cb-086ae0fe2f88/001-nike-logos-swoosh-black.jpg?m=eyJlZGl0cyI6eyJqcGVnIjp7InF1YWxpdHkiOjEwMH0sIndlYnAiOnsicXVhbGl0eSI6MTAwfSwiZXh0cmFjdCI6eyJsZWZ0IjowLCJ0b3AiOjAsIndpZHRoIjo1MDAwLCJoZWlnaHQiOjI4MTN9LCJyZXNpemUiOnsid2lkdGgiOjEwODB9fX0%3D&signature=c29752cfe04e0502ca9f108ca130f79f08ce106d624d5c0e20432503c4ab34e4',
            alt: 'Nike',
            link: '#',
        },
        {
            imageUrl: 'https://1000logos.net/wp-content/uploads/2021/04/Puma-logo-1536x765.png',
            alt: 'Puma',
            link: '#',
        },
        {
            imageUrl: 'https://images.seeklogo.com/logo-png/16/1/adidas-logo-png_seeklogo-168370.png',
            alt: 'Addidas',
            link: '#',
        },
        {
            imageUrl: 'https://images.seeklogo.com/logo-png/12/1/skechers-logo-png_seeklogo-127487.png?v=1956233690105326184',
            alt: 'Skechers',
            link: '#',
        },
        {
            imageUrl: 'https://images.seeklogo.com/logo-png/5/1/fila-logo-png_seeklogo-54326.png',
            alt: 'Filla',
            link: '#',
        },
        {
            imageUrl: 'https://seeklogo.com/images/W/woodland-logo-BDCA948AA5-seeklogo.com.png',
            alt: 'Woodland',
            link: '#',
        },
        {
            imageUrl: 'https://images.seeklogo.com/logo-png/1/1/bata-logo-png_seeklogo-16999.png?v=1956237638703008512',
            alt: 'Bata',
            link: '#',
        },
        
        {
            imageUrl: 'https://images.seeklogo.com/logo-png/18/1/us-polo-assn-logo-png_seeklogo-188407.png',
            alt: 'U.S. Polo',
            link: '#',
        },
        {
            imageUrl: 'https://seeklogo.com/images/A/allen-solly-logo-965039B17A-seeklogo.com.png',
            alt: 'Allen solly',
            link: '#',
        },
        {
            imageUrl: 'https://images.seeklogo.com/logo-png/4/1/diesel-logo-png_seeklogo-41152.png',
            alt: 'Diesel',
            link: '#',
        },
        {
            imageUrl: 'https://images.seeklogo.com/logo-png/1/1/armani-exchange-logo-png_seeklogo-10903.png',
            alt: 'Armani Exchange',
            link: '#',
        },
        {
            imageUrl: 'https://images.seeklogo.com/logo-png/14/1/titan-logo-png_seeklogo-140287.png?v=1956247400724349304',
            alt: 'Titan',
            link: '#',
        },
        {
            imageUrl: 'https://images.seeklogo.com/logo-png/15/1/yonex-logo-png_seeklogo-155286.png',
            alt: 'Yonex',
            link: '#',
        },
        {
            imageUrl: 'https://images.seeklogo.com/logo-png/22/1/li-ning-logo-png_seeklogo-224246.png',
            alt: 'Li-Ning',
            link: '#',
        },
    ];

    return (
        <div className="bg-white py-16 md:py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">Shop by Brands</h2>
                    <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                        Explore your favorite brands and discover their latest collections
                    </p>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4 md:gap-6">
                    {brands.map((brand, index) => (
                        <a
                            key={index}
                            href={brand.link}
                            className="group relative bg-white rounded-2xl border-2 border-gray-100 overflow-hidden transition-all duration-300 hover:border-blue-500 hover:shadow-xl transform hover:-translate-y-1"
                        >
                            <div className="aspect-square p-6 flex items-center justify-center">
                                <img
                                    src={brand.imageUrl}
                                    alt={brand.alt}
                                    className="w-full h-20 object-contain transition-all duration-300 group-hover:scale-110"
                                />
                            </div>
                            {/* Hover overlay */}
                            <div className="absolute inset-0 bg-gradient-to-t from-blue-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BrandLogos;